/** @file The catalog key of the human label of each shortcut binding id (review D10). */
import type { CatalogKey } from '@pose2d/i18n/types';

const LABELS: Readonly<Record<string, CatalogKey>> = {
  'assets.delete': 'shortcutsPanel.action.assetsDelete',
  'curves.cancelGesture': 'shortcutsPanel.action.curvesCancelGesture',
  'curves.frameAll': 'curves.frameAll',
  'export.open': 'exportDialog.open',
  'hierarchy.delete': 'shortcutsPanel.action.hierarchyDelete',
  'history.redo': 'common.redo',
  'history.redoAlt': 'shortcutsPanel.action.redoAlt',
  'history.undo': 'common.undo',
  'shell.openSettings': 'shell.settings',
  'timeline.copyKeys': 'shortcutsPanel.action.timelineCopyKeys',
  'timeline.deleteKeys': 'shortcutsPanel.action.timelineDeleteKeys',
  'timeline.firstFrame': 'panels.timeline.first',
  'timeline.keyBones': 'panels.timeline.key',
  'timeline.lastFrame': 'panels.timeline.last',
  'timeline.nextFrame': 'panels.timeline.next',
  'timeline.pasteKeys': 'shortcutsPanel.action.timelinePasteKeys',
  'timeline.playPause': 'shortcutsPanel.action.timelinePlayPause',
  'timeline.prevFrame': 'panels.timeline.prev',
  'tool.createBone': 'tools.createBone.title',
  'tool.editMesh': 'tools.editMesh.title',
  'tool.grabItem': 'tools.grabItem.title',
  'tool.ik': 'tools.ik.title',
  'tool.paintWeights': 'tools.paintWeights.title',
  'tool.rotate': 'tools.rotate.title',
  'tool.scale': 'tools.scale.title',
  'tool.select': 'tools.select.title',
  'tool.translate': 'tools.translate.title',
  'viewport.cancel': 'shortcutsPanel.action.viewportCancel',
  'viewport.frameSelection': 'viewport.frameSelection',
  'viewport.key': 'viewport.key',
  'viewport.toggleMode': 'shortcutsPanel.action.viewportToggleMode',
  'viewport.toggleSnap': 'shortcutsPanel.action.viewportToggleSnap',
};

/** The label's key, or null for an id the table does not know (the row then shows the id alone). */
export function shortcutLabelKey(id: string): CatalogKey | null {
  return LABELS[id] ?? null;
}
